import { __rest, __assign, __spreadArray, __read } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef, useRef } from 'react';
import { useRect } from '@reach/rect';
import { useComposedRefs } from '../hooks/useComposedRefs.js';
import { useTheme } from '../hooks/useTheme.js';
import '@compono/ui-theme-compono';
import '@emotion/is-prop-valid';
import 'lodash.get';
import { getZIndex } from '../utils/getZIndex.js';
import 'deepmerge';
import { useSimulateTabNavigationForReactTree, getCollisions, positionDefault } from './usePopover.js';

function getStyles(position, targetRect, popoverRect, unstable_observableRefs) {
    return popoverRect
        ? position.apply(void 0, __spreadArray([targetRect,
            popoverRect], __read(unstable_observableRefs.map(function (ref) { return ref === null || ref === void 0 ? void 0 : ref.current; })), false)) : { visibility: "hidden" };
}
var PopoverImpl = forwardRef(function PopoverImpl(_a, forwardedRef) {
    var _b, _c;
    var _d = _a.as, Comp = _d === void 0 ? "div" : _d, targetRef = _a.targetRef, anchorRef = _a.anchorRef, _e = _a.position, position = _e === void 0 ? positionDefault : _e, _f = _a.unstable_observableRefs, unstable_observableRefs = _f === void 0 ? [] : _f, props = __rest(_a, ["as", "targetRef", "anchorRef", "position", "unstable_observableRefs"]);
    var popoverRef = useRef(null);
    var popoverRect = useRect(popoverRef, { observe: !props.hidden });
    var targetRect = useRect(targetRef, { observe: !props.hidden });
    // add anchorRef/anchorRect for use case that position of popover is not referencing to the targetRect/targetRef
    var anchorRect = anchorRef &&
        anchorRef.current &&
        useRect(anchorRef, { observe: !props.hidden });
    var ref = useComposedRefs(popoverRef, forwardedRef);
    var handleStyleProps = useTheme().handleStyleProps;
    useSimulateTabNavigationForReactTree(targetRef, popoverRef);
    // Get the zIndex of the trigger button
    // If the trigger button has a z-index (eg when in a dialog (zIndex: 999)), assign the same
    // zIndex to the popover so it displays above the trigger.
    // If the trigger button doesn't have a zIndex (the usual case), then do not assign a zIndex to
    // the popover so that the popover will show under the fixed navbar (zIndex: 100)
    var zIndex = targetRef.current ? getZIndex(targetRef.current) : undefined;
    var baseStyle = __assign(__assign({ position: "absolute" }, getStyles(position, anchorRect || targetRect, popoverRect, unstable_observableRefs)), (zIndex && { zIndex: zIndex }));
    var rect = anchorRect || targetRect;
    var directionUp = (rect && popoverRect
        ? getCollisions(rect, popoverRect)
        : { directionUp: true }).directionUp;
    (_c = (_b = ((anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current) || targetRef.current)) === null || _b === void 0 ? void 0 : _b.setAttribute) === null || _c === void 0 ? void 0 : _c.call(_b, "data-direction", directionUp ? "up" : "down");
    var forwardProps = handleStyleProps(props, {
        baseStyle: baseStyle,
    });
    return (jsx(Comp, __assign({ "data-reach-popover": "", "data-direction": directionUp ? "up" : "down", ref: ref }, forwardProps)));
});

export { PopoverImpl };
//# sourceMappingURL=PopoverImpl.js.map
